import { render, staticRenderFns } from "./ReportStock.vue?vue&type=template&id=6d4f1630&scoped=true&"
import script from "./ReportStock.vue?vue&type=script&lang=js&"
export * from "./ReportStock.vue?vue&type=script&lang=js&"
import style0 from "./ReportStock.vue?vue&type=style&index=0&id=6d4f1630&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f1630",
  null
  
)

export default component.exports